import {
    PersonalInfo,
    Skill,
    Experience,
    Testimonial,
    SocialLink,
    ContactInfo
} from '../types';

export const defaultPersonalInfo: PersonalInfo = {
    name: "Yabets Kifle",
    title: "Systems Architect & Software Engineer",
    tagline: "Building high-performance digital infrastructure with surgical precision.",
    description: "Specializing in React, TypeScript, and Node.js ecosystems. I transform complex architectural requirements into scalable, executive-grade software solutions.",
    profileImage: "/image/me.jpg",
    profileImageAlt: "Yabets Kifle - Systems Architect",
    resumeUrl: "/resume.pdf",
    githubCommits: "1.2k+",
    happyClients: "50+",
    githubUsername: "yabets-kifle",
    heroStatus: "Operational: Available for high-impact deployments",
    subtitle: "Precision. Performance. Scalability.",
    heroTitlePrefix: "Architecting",
    heroTitleHighlight: "Digital Performance",
    typingTexts: [],
    // Section Specifics
    skillsTitle: "Core Competencies",
    skillsSubtitle: "High-performance technical stack for enterprise deployment.",
    experienceTitle: "Operational History",
    experienceSubtitle: "Strategic leadership and technical execution timeline.",
    projectsTitle: "Mission Reports",
    projectsSubtitle: "Detailed analysis of high-impact technical deployments.",
    testimonialsTitle: "Stakeholder Validation",
    testimonialsSubtitle: "Executive feedback from project partners.",
    contactTitle: "Initiate Collaboration",
    contactSubtitle: "Facilitating superior software solutions and executive consultation.",
    contactBadge: "Engagement Gateway"
};

export const defaultContactInfo: ContactInfo = {
    email: 'jabez.kifle@gmail.com',
    phone: '+251 900 000 000',
    location: 'Addis Ababa, Ethiopia'
};

export const defaultSkills: Skill[] = [
    { id: '1', name: 'React / Next.js', icon: 'Code2', proficiency: 95, category: 'frontend', yearsOfExperience: 3 },
    { id: '2', name: 'TypeScript', icon: 'FileCode', proficiency: 90, category: 'frontend', yearsOfExperience: 3 },
    { id: '3', name: 'Node.js', icon: 'Server', proficiency: 85, category: 'backend', yearsOfExperience: 2 },
    { id: '4', name: 'System Design', icon: 'Layout', proficiency: 80, category: 'tools', yearsOfExperience: 2 }
];

export const defaultExperiences: Experience[] = [
    {
        id: '1',
        company: 'Freelance Execution',
        position: 'Lead Software Engineer',
        duration: '2023 - Present',
        description: 'Architecting end-to-end solutions for international clients with a focus on scalability and performance optimization.',
        logo: '',
        logoAlt: 'Freelance',
        technologies: ['React', 'TypeScript', 'Node.js', 'PostgreSQL']
    }
];

export const defaultTestimonials: Testimonial[] = [
    {
        id: '1',
        name: 'Executive Partner',
        position: 'Managing Director',
        company: 'Visionary Systems',
        content: 'Operational efficiency and technical precision. Delivered core infrastructure with outstanding attention to architectural detail.',
        avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7",
        avatarAlt: 'Executive portrait',
        rating: 5
    }
];

export const defaultSocialLinks: SocialLink[] = [
    { id: '1', platform: 'WhatsApp', url: 'https://wa.me/251900000000', icon: 'WhatsApp', username: 'WhatsApp' },
    { id: '2', platform: 'LinkedIn', url: 'https://linkedin.com/in/yabets-kifle', icon: 'Linkedin', username: 'yabets-kifle' },
    { id: '3', platform: 'Telegram', url: 'https://t.me/yabets_kifle', icon: 'Telegram', username: 'yabets_kifle' },
    { id: '4', platform: 'GitHub', url: 'https://github.com/yabets-kifle', icon: 'Github', username: 'yabets-kifle' },
    { id: '5', platform: 'Email', url: 'mailto:jabez.kifle@gmail.com', icon: 'Mail', username: 'Email' }
];
